<template>
  <div>
    <Logo />
    <Header />

    <Body />
  </div>
</template>

<script>
import Logo from '../../components/Logo/index.vue'
import Header from '../../components/Header/index.vue'
import Body from '../../components/Body/index.vue'
export default {
  props: ['sendGaEvent'],
  data() {
    return {
      props: this.$root.$data.props
    }
  },
  components: {
    Logo,
    Header,
    Body
  }
}
</script>
